const CUSTOMER_FIELDS = [
    'name',
    'surname',
    'email',
    'phone',
    'address',
    'postcode',
    'city',
    'birthdate',
]

const INVOICE_FIELDS = [
    'invoiceType',
    'invoiceNip',
    'invoiceDisplayName',
    'invoiceStreet',
    'invoiceBuildingNumber',
    'invoiceLocalNumber',
    'invoiceCity',
    'invoicePostcode',
    'invoiceCountry',
]

const PARTICIPANT_FIELDS = [
    'name',
    'surname',
    'birthdate',
    'gender',
]

const pick = (source, fields) =>
    fields.reduce((result, field) => {
        if (Object.prototype.hasOwnProperty.call(source, field)) {
            result[field] = source[field]
        }

        return result
    }, {})

export const mapUddsCheckoutRecoveryCapture = (
    reservation,
    context,
) => {
    const {
        form,
        selectedInsurance,
        selectedParkingAirport,
        selectedParkingOffer,
        paymentMethod,
        promotionCodes,
        useCashbackForPay,
    } = reservation

    return {
        offerHash: context.offerHash,
        operator: context.operator,
        extType: context.extType,
        od: context.od,
        do: context.do,
        length: context.length,
        dorosli: context.dorosli,
        dzieci: context.dzieci,
        udds_snapshot: context.udds_snapshot,

        ...pick(form, CUSTOMER_FIELDS),
        ...pick(form, INVOICE_FIELDS),

        adults: form.adults.map((participant) =>
            pick(participant, PARTICIPANT_FIELDS),
        ),

        children: form.children.map((participant) =>
            pick(participant, PARTICIPANT_FIELDS),
        ),

        selectedInsurance: selectedInsurance
            ? {
                variant: selectedInsurance.variant,
            }
            : null,

        selectedParkingAirport:
            selectedParkingAirport === undefined
                ? null
                : selectedParkingAirport,

        selectedParkingOffer: selectedParkingOffer
            ? {
                id: selectedParkingOffer.id,
                parking: selectedParkingOffer.parking
                    ? {
                        id: selectedParkingOffer.parking.id,
                    }
                    : null,
            }
            : null,

        payment_method: paymentMethod || null,
        promotionCodes: [...promotionCodes],
        useCashbackForPay: Boolean(useCashbackForPay),
    }
}
